import BaseService from './_base.service';

export const dealermanufactureService = {
    page,
    edit,
    search,
    create,
    searchfamily,
    searchNotfamily,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/dealer/family/manufacture/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/dealer/family/manufacture/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/dealer/family/manufacture/"+id, body, callback, true)
}
function searchfamily(page,size,id,filter, callback) {
    return BaseService.post("/dealer/family/manufacture/"+id+"/page/"+page+"/"+size,filter, callback, true)
}

function searchNotfamily(page,size,id,filter, callback) {
    return BaseService.post("/dealer/family/manufacture/"+id+"/not/page/"+page+"/"+size,filter, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/dealer/family/manufacture/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/dealer/family/manufacture/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/dealer/family/manufacture/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/dealer/family/manufacture/"+id+"/logic", callback);
}
